import { createFileRoute } from "@tanstack/react-router";
import dayjs from "dayjs";

import { dateRangeQueryParamsSchema, useDriverLogsQueryParams } from "@/features/app/logs/hooks";
import { useSession } from "@/hooks/@custom/useSession";
import { DriverLogRow } from "@/pages/App/Driver/DriverLogs/DriverLogRow";
import { useListSchedulingDeletedByDriverInfiniteQuery } from "@/store/apis/nextcargo/scheduling";

export const Route = createFileRoute("/app/logs/expirados")({
  component: RouteComponent,
  validateSearch: dateRangeQueryParamsSchema
});

function RouteComponent() {
  // const { data } = Route.useLoaderData();
  const [query] = useDriverLogsQueryParams();

  const { driver } = useSession();
  const { data: list } = useListSchedulingDeletedByDriverInfiniteQuery({
    id: Number(driver?.id),
    minDate: query?.dateRange?.[0],
    maxDate: query?.dateRange?.[1]
  });
  const data = list?.pages.flatMap((item) => item.data).filter(Boolean);

  return (
    <>
      {!!data?.length &&
        data.map((item) => (
          <DriverLogRow
            key={item.id}
            order={item.order.code}
            transporter={item.truck.owner}
            client={item.company.name}
            createAt={dayjs(item.createAt).format("DD/MM/YYYY - HH:mm")}
            expirationDate={dayjs(item.expirationDate).format("DD/MM/YYYY - HH:mm")}
          />
        ))}

      {!data?.length && <p style={{ textAlign: "center", marginTop: "20px" }}>Não há registros expirados.</p>}
    </>
  );
}
